document.addEventListener("DOMContentLoaded", function () {
  window.DETROPOLIS_AUDIO = window.DETROPOLIS_AUDIO || {
    current: null,
    players: new Set()
  };

  const GLOBAL = window.DETROPOLIS_AUDIO;

  function pauseOthers(except) {
    GLOBAL.players.forEach((player) => {
      if (player !== except) {
        try { player.pause(); } catch (e) {}
      }
    });
  }

  function registerPlayer(ws, button) {
    GLOBAL.players.add(ws);

    ws.on("play", () => {
      pauseOthers(ws);
      GLOBAL.current = ws;
      if (button) button.textContent = "⏸";
    });

    ws.on("pause", () => {
      if (GLOBAL.current === ws) GLOBAL.current = null;
      if (button) button.textContent = "▶";
    });

    ws.on("finish", () => {
      if (GLOBAL.current === ws) GLOBAL.current = null;
      if (button) button.textContent = "▶";
    });

    ws.on("error", () => {
      if (button) button.textContent = "▶";
    });
  }

  function createWave(container, height = 40, progressColor = "#d82323") {
    if (!container) return null;

    if (container.dataset.initialized === "true" && container._wavesurfer) {
      return container._wavesurfer;
    }

    const audioUrl = container.dataset.audio;
    if (!audioUrl || typeof WaveSurfer === "undefined") return null;

    const ws = WaveSurfer.create({
      container,
      height,
      responsive: true,
      barWidth: 2,
      barGap: 1.8,
      barRadius: 2,
      cursorWidth: 0,
      normalize: true,
      waveColor: "rgba(255,255,255,0.85)",
      progressColor,
      dragToSeek: true
    });

    ws.load(audioUrl);

    container.dataset.initialized = "true";
    container._wavesurfer = ws;

    return ws;
  }

  /* ================= MAIN PLAYER ================= */

  const mainWave = document.getElementById("waveform");
  const mainBtn = document.getElementById("playPauseBtn");
  let mainWS = null;

  function initMainPlayer() {
    if (mainWS || !mainWave) return;
    mainWS = createWave(mainWave, 80, "#ff5a5a");
    if (!mainWS) return;

    registerPlayer(mainWS, mainBtn);
  }

  if (mainBtn) {
    mainBtn.addEventListener("click", () => {
      initMainPlayer();
      if (!mainWS) return;

      if (GLOBAL.current && GLOBAL.current !== mainWS) {
        try { GLOBAL.current.pause(); } catch (e) {}
      }

      mainWS.isPlaying() ? mainWS.pause() : mainWS.play();
    });
  }

  /* ================= SAMPLE PLAYERS ================= */

  const sampleEls = Array.from(document.querySelectorAll("[data-sample]"));
  const samplePlayers = new Map();

  function initSample(sampleEl) {
    if (!sampleEl) return null;
    if (samplePlayers.has(sampleEl)) return samplePlayers.get(sampleEl);

    const waveEl = sampleEl.querySelector(".waveform");
    const btn = sampleEl.querySelector(".play-btn");
    const ws = createWave(waveEl, 40, "#d82323");

    if (!ws) return null;

    registerPlayer(ws, btn);
    samplePlayers.set(sampleEl, ws);

    if (btn && btn.dataset.bound !== "true") {
      btn.dataset.bound = "true";

      btn.addEventListener("click", () => {
        const currentWS = initSample(sampleEl);
        if (!currentWS) return;

        if (GLOBAL.current && GLOBAL.current !== currentWS) {
          try { GLOBAL.current.pause(); } catch (e) {}
        }

        currentWS.isPlaying() ? currentWS.pause() : currentWS.play();
      });
    }

    return ws;
  }

  function forceInitNearAudios() {
    sampleEls.forEach((el) => {
      const rect = el.getBoundingClientRect();

      if (rect.top < window.innerHeight + 900 && rect.bottom > -300) {
        initSample(el);
      }
    });

    const main = document.querySelector("[data-main-player]");
    if (main) {
      const rect = main.getBoundingClientRect();

      if (rect.top < window.innerHeight + 900 && rect.bottom > -300) {
        initMainPlayer();
      }
    }
  }

  let ticking = false;

  function safeForceInit() {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(() => {
      forceInitNearAudios();
      ticking = false;
    });
  }

  /* Observer amplio */
  const waveObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      if (entry.target.matches("[data-main-player], .audio-preview, .main-player")) {
        initMainPlayer();
      }

      if (entry.target.matches("[data-sample]")) {
        initSample(entry.target);
      }

      /* Importante: NO hacemos unobserve.
         Así el navegador puede reintentar si el usuario baja rápido. */
    });
  }, {
    rootMargin: "900px 0px",
    threshold: 0
  });

  const mainPlayerRoot = document.querySelector("[data-main-player]");
  if (mainPlayerRoot) waveObserver.observe(mainPlayerRoot);

  sampleEls.forEach((el) => {
    waveObserver.observe(el);
    initSample(el); /* clave: deja los botones listos aunque el scroll sea rápido */
  });

  window.addEventListener("scroll", safeForceInit, { passive: true });
  window.addEventListener("resize", safeForceInit);
  window.addEventListener("touchstart", safeForceInit, { passive: true });

  forceInitNearAudios();

  /* ================= REVEALS ================= */

  const revealEls = document.querySelectorAll("[data-reveal]");

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
      }
    });
  }, {
    threshold: 0.14,
    rootMargin: "0px 0px -60px 0px"
  });

  revealEls.forEach((el) => revealObserver.observe(el));

  /* ================= FAQ ================= */

  document.querySelectorAll(".faq-item").forEach((item) => {
    const btn = item.querySelector(".faq-question");
    const answer = item.querySelector(".faq-answer");
    const toggle = item.querySelector(".faq-toggle");

    if (!btn || !answer || !toggle) return;

    btn.addEventListener("click", function () {
      const isOpen = item.classList.contains("is-open");

      document.querySelectorAll(".faq-item").forEach((other) => {
        other.classList.remove("is-open");

        const otherBtn = other.querySelector(".faq-question");
        const otherAnswer = other.querySelector(".faq-answer");
        const otherToggle = other.querySelector(".faq-toggle");

        if (otherBtn) otherBtn.setAttribute("aria-expanded", "false");
        if (otherAnswer) otherAnswer.style.maxHeight = null;
        if (otherToggle) otherToggle.textContent = "+";
      });

      if (!isOpen) {
        item.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
        answer.style.maxHeight = answer.scrollHeight + "px";
        toggle.textContent = "−";
      }
    });
  });

  /* ================= VIDEO PERFORMANCE ================= */

  const kitVideos = document.querySelectorAll("video.kit-cover");

  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, {
    rootMargin: "180px 0px",
    threshold: 0.15
  });

  kitVideos.forEach((video) => {
    video.pause();
    videoObserver.observe(video);
  });
});

/* ===== GIFT CARD LICENSE STATUS ===== */

(function () {
  function updateGiftLicenseCounter() {
    document.querySelectorAll(".gift-license-counter").forEach((counter) => {
      const left = Number(counter.dataset.left || 0);
      const number = counter.querySelector(".gift-license-number");
      const copy = counter.querySelector(".gift-license-copy");

      if (left <= 0) {
        counter.classList.add("is-sold-out");
        if (number) number.textContent = "0";
        if (copy) copy.textContent = "bonus ya agotado";
      }
    });
  }

  document.addEventListener("DOMContentLoaded", updateGiftLicenseCounter);

  // 🔥 IMPORTANTE: cuando cambias de tab (porque se re-renderiza el HTML)
  document.addEventListener("click", function () {
    setTimeout(updateGiftLicenseCounter, 250);
  });
})();